export default __webpack_public_path__ + "static/hero-background-e6976ce1ab6c0297c6bca3226b8f11d1.png";